export enum Environment {
    PROD = 'prod',
    STAGING = 'stag',
    QA = 'qa',
    QA2 = 'qa2',
    QA3 = 'qa3',
    QA4 = 'qa4',
    QA5 = 'qa5',
    DEV = 'dev'
}
